import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import RxButton from "../../components/RxButton";
import RxDialog from "../../components/RxDialog";
import RxStepForm from "../../components/RxStepForm";
import { DescriptionObject } from "../../components/RxStepForm/RxStepForm";
import api from "../../config/AxiosConfig";
import {
	isNullOrUndefined,
	isNullOrUndefinedOrEmpty,
} from "../../utils/CommonFunctions";
import PaymentInfoApproveStep from "./PaymentInfoApproveStep";
import PaymentInfoStep from "./PaymentInfoStep";
import {
	POSPayment,
	RxPaymentObject,
	RxPaymentObjectInıtialValue,
} from "./PaymentObject";
import styles from "./PaymentPage.module.css";
import PaymentStep from "./PaymentStep";

export interface PaymentStepFormValidationObject {
	values: RxPaymentObject;
	isInfoStepValid: boolean;
	isApproveStepValid: boolean;
	isPayStepValid: boolean;
	validRequset: boolean;
}

const PaymentPage = () => {
	const history = useHistory();

	const [errorMessage, setErrorMessage] = useState<string>("");
	const [paymentValidationObject, setPaymentValidationObject] =
		useState<PaymentStepFormValidationObject>({
			values: RxPaymentObjectInıtialValue,
			isInfoStepValid: false,
			isApproveStepValid: false,
			isPayStepValid: false,
			validRequset: false,
		});

	const getValues = async () => {
		await api
			.get("/1/payment")
			.then((response: RxPaymentObject) => {
				if (!isNullOrUndefined(response.saleDetail)) {
					setPaymentValidationObject(
						(
							prev: PaymentStepFormValidationObject
						): PaymentStepFormValidationObject => {
							return {
								...prev,
								values: response,
								validRequset: true,
							};
						}
					);
				} else {
					history.push("/");
				}
			})
			.catch((ex: any) => {
				if (ex.response?.data?.code === "232") {
					setErrorMessage(ex.response?.data?.message);
				}
			});
	};

	useEffect(() => {
		getValues();
	}, []); // eslint-disable-line

	const getDescription = (): DescriptionObject[] => {
		let returnDescription: DescriptionObject[] = [];
		paymentValidationObject.values.saleDetail.products.forEach((item) => {
			let description = "";
			if (returnDescription.length !== 0) {
				description += ", ";
			}
			description += item.quantity + " " + item.productName;
			returnDescription.push({
				value: description,
				isBold: true,
			});
		});
		returnDescription.push({
			value: " için Toplam Tutar KDV dahil ",
		});
		returnDescription.push({
			value:
				paymentValidationObject.values.saleDetail.totalPriceWithKdv.toFixed(
					2
				) + " TL",
			isBold: true,
		});
		returnDescription.push({
			value: "'dir.",
		});
		return returnDescription;
	};

	const completePayment = async () => {
		await api
			.post("/1/payment/pay/values", paymentValidationObject.values)
			.then((data: POSPayment) => {
				// Banka 3D Secure adresi backend'den geliyor. Build zamanında bake edilen
				// VITE_SANAL_POS_URL boş kalırsa form kendi origin'ine POST edip 405 alıyordu.
				const posUrl =
					data.posUrl || import.meta.env.VITE_SANAL_POS_URL || "";
				if (isNullOrUndefinedOrEmpty(posUrl)) {
					setErrorMessage(
						"Ödeme sayfasına yönlendirilemedi. Lütfen daha sonra tekrar deneyin."
					);
					return;
				}
				document.forms[0].setAttribute("action", posUrl);

				// RX-2286 ile düzenleme işlemi gerçekleştirilecek
				document.forms[0].children[1].setAttribute("value", data.clientId);
				document.forms[0].children[2].setAttribute("value", data.oid);
				document.forms[0].children[3].setAttribute("value", data.amount);
				document.forms[0].children[4].setAttribute("value", data.okUrl);
				document.forms[0].children[5].setAttribute("value", data.failUrl);
				document.forms[0].children[6].setAttribute("value", data.storeType);
				document.forms[0].children[7].setAttribute("value", data.rnd);
				document.forms[0].children[8].setAttribute("value", data.hash);
				document.forms[0].children[9].setAttribute("value", data.currency);
				document.forms[0].children[10].setAttribute("value", data.lang);
				document.forms[0].children[11].setAttribute(
					"value",
					data.processType
				);
				document.forms[0].children[12].setAttribute(
					"value",
					data.hashAlgorithm
				);

				document.forms[0].submit();
			})
			.catch((ex) => {
				// Talep ile hatalar ele alınacak ve bilgilendirilecek
				console.log("ex", ex);
				setErrorMessage(
					"Ödeme işlemi başlatılamadı. Lütfen daha sonra tekrar deneyin."
				);
			});
	};

	return (
		<>
			{paymentValidationObject.validRequset && (
				<RxStepForm
					title="Satın Alma İşlemi"
					description={getDescription()}
					className={styles.stepForm}
					steps={[
						{
							title: "Bilgiler",
							content: (
								<PaymentInfoStep
									setValidataResult={setPaymentValidationObject}
									values={paymentValidationObject.values}
								/>
							),
							valid: paymentValidationObject.isInfoStepValid,
						},
						{
							title: "Onay",
							content: (
								<PaymentInfoApproveStep
									setValidataResult={setPaymentValidationObject}
									values={paymentValidationObject.values}
								/>
							),
							valid: paymentValidationObject.isApproveStepValid,
						},
						{
							title: "Ödeme",
							content: (
								<PaymentStep
									setValidataResult={setPaymentValidationObject}
									values={paymentValidationObject.values}
								/>
							),
							valid: paymentValidationObject.isPayStepValid,
							backButtonSize: "medium",
							nextButtonName: "Ödemeyi Tamamla",
							nextButtonColor: "secondary",
							nextButtonSize: "medium",
							nextButtonOnClick: completePayment,
						},
					]}
				/>
			)}
			{!isNullOrUndefinedOrEmpty(errorMessage) && (
				<RxDialog
					title={"Uyarı"}
					maxWidth="sm"
					fullWidth
					status="error"
					handleClose={() => {
						history.push("/edit-user");
					}}
					actions={
						<>
							<RxButton
								fullWidth
								label="Tamam"
								color="primary"
								variant="contained"
								onClick={() => {
									history.push("/edit-user");
								}}
							/>
						</>
					}
				>
					<div>{errorMessage}</div>
				</RxDialog>
			)}
		</>
	);
};

export default PaymentPage;
